import { FinalCut, RenderStatus } from 'services/finalcut.service';
import { PaymentStatus } from 'services/payment.service';
import { useAppSelector } from 'store/store-hooks';

interface Props {
  fc: FinalCut;
}

export const FcStatus = ({ fc }: Props) => {
  const progress = useAppSelector((state) => state.fc__renderServer.fcProgress[fc.id]);

  if (progress) return RenderStatus[RenderStatus.processing];

  if (fc.payment) {
    return fc.payment?.status === PaymentStatus.Completed
      ? RenderStatus[fc.status]
      : `Payment ${PaymentStatus[fc.payment?.status ?? PaymentStatus.Created]}`;
  } else if (fc.subscription) {
    return RenderStatus[fc.status];
  }
};
